import React, { useState } from "react";
import ModalComponent from "../../../features/ModalComponent";
import { SubmitHandler, useForm } from "react-hook-form";
import { passValidator } from "../../../utils/formsValidation";
import FormInput from "../../../utils/FormInput";
import useApiRequest from "../../../utils/hooks/useApiRequest";
import { useDispatch } from "react-redux";
import { USER_CHANGE_PASS_URL } from "../../api/apiRoutes";
import useFacility from "../../../utils/hooks/useFacility";
import { USER_TOKEN } from "../../store/auth/authMiddleware";
import { setSuccessMessage } from "../../store/alerts/alertsActions";

type Inputs = {
  oldPassword: string;
  newPassword: string;
};

const ChangePassword: React.FC = () => {
  const [open, setOpen] = useState(false);
  const { post } = useApiRequest();
  const dispatch = useDispatch();
  const facilityIds = useFacility();
  const userToken = sessionStorage.getItem(USER_TOKEN);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<Inputs>();

  const handleChangePassword: SubmitHandler<Inputs> = async (data) => {
    const parsedUserToken = userToken ? JSON.parse(userToken).sessionToken : "";
    const { isError } = await post(USER_CHANGE_PASS_URL(facilityIds), {
      oldpassword: data.oldPassword,
      password: data.newPassword,
      token: parsedUserToken,
    });

    if (!isError) {
      dispatch(setSuccessMessage("Operacja przebiegła pomyślnie"));
      setOpen(false);
    }
  };

  return (
    <React.Fragment>
      <button className={"setting-button"} onClick={() => setOpen(true)}>
        Zmiana hasła
      </button>
      {open && (
        <ModalComponent
          open={open}
          closeModal={() => setOpen(false)}
          title={"Zmiana hasła"}
          onAccept={handleSubmit(handleChangePassword)}
        >
          <form onSubmit={handleSubmit(handleChangePassword)}>
            <FormInput
              type={"password"}
              name={"oldPassword"}
              text={"Stare hasło"}
              register={{ ...register("oldPassword", { ...passValidator(true) }) }}
              errors={errors}
              isLabel
            />
            <FormInput
              type={"password"}
              name={"newPassword"}
              text={"Nowe hasło"}
              register={{ ...register("newPassword", { ...passValidator(true) }) }}
              errors={errors}
              isLabel
            />
          </form>
        </ModalComponent>
      )}
    </React.Fragment>
  );
};

export default ChangePassword;
